import axios from 'axios';

const authApiClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_URL
});

export default authApiClient;
